import { ReactNode } from 'react';

import { cx } from '@libs/classnames';
import { ErrorIcon } from '@ui/icons/ErrorIcon';

import styles from './Notice.module.css';

type Props = {
  // отступы и место на странице задает владелец
  className?: string;
  // error — красная иконка ошибки над заголовком
  tone?: 'info' | 'error';
  // large — крупный заголовок и узкий текст: целый экран страницы телефона
  size?: 'default' | 'large';
  title: string;
  text?: string;
  // действие под текстом
  children?: ReactNode;
};

// Сообщение вместо содержимого: нет связи, ссылка недействительна, трансляция закончилась
export function Notice({
  className,
  tone = 'info',
  size = 'default',
  title,
  text,
  children,
}: Props) {
  return (
    <div className={cx(styles.notice, { [styles.is_large]: size === 'large' }, className)}>
      {tone === 'error' && (
        <span className={styles.notice__icon}>
          <ErrorIcon />
        </span>
      )}
      <h2 className={styles.notice__title}>{title}</h2>
      {text && <p className={styles.notice__text}>{text}</p>}
      {children}
    </div>
  );
}
